import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const scrollOrNavigate = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
    } else {
        window.location.href = `/#${sectionId}`;
    }
};

const Footer = () => {
    const { t } = useLanguage();
    const styles = {
        footer: {
            backgroundColor: '#2B2B2B',
            padding: '60px 32px 32px',
            borderTop: '1px solid #E5E5E5',
        },
        container: {
            maxWidth: '1400px',
            margin: '0 auto',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '48px',
            marginBottom: '48px',
        },
        column: {
            display: 'flex',
            flexDirection: 'column',
        },
        logo: {
            width: '40px',
            height: '40px',
            objectFit: 'contain',
            marginBottom: '12px',
        },
        logoText: {
            fontSize: '24px',
            fontWeight: '800',
            color: '#3457D5',
            marginBottom: '16px',
        },
        description: {
            fontSize: '14px',
            color: '#BEBEBE',
            lineHeight: '1.6',
        },
        columnTitle: {
            fontSize: '16px',
            fontWeight: '700',
            color: '#FFFFFF',
            marginBottom: '20px',
        },
        linkList: {
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
        },
        link: {
            fontSize: '14px',
            color: '#BEBEBE',
            textDecoration: 'none',
            transition: 'color 0.3s',
            cursor: 'pointer',
        },
        bottom: {
            paddingTop: '32px',
            borderTop: '1px solid #444444',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '20px',
        },
        copyright: {
            fontSize: '14px',
            color: '#E0E0E0',
            opacity: 0.8,
        },
        socialLinks: {
            display: 'flex',
            gap: '24px',
            alignItems: 'center',
        },
        socialIcon: {
            color: '#E0E0E0',
            transition: 'color 0.3s',
            cursor: 'pointer',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.footer.padding = '40px 20px 24px';
        styles.grid.gridTemplateColumns = '1fr 1fr';
        styles.grid.gap = '32px';
        styles.bottom.flexDirection = 'column';
        styles.bottom.textAlign = 'center';
    }

    return (
        <footer style={styles.footer}>
            <div style={styles.container}>
                <div style={styles.grid}>
                    {/* Brand */}
                    <div style={styles.column}>
                        <img src="/corpusio-logo.webp" alt="Corpusio" style={styles.logo} />
                        <div style={styles.logoText}>Corpusio</div>
                        <p style={styles.description}>
                            {t('footer.description')}
                        </p>
                    </div>

                    {/* Product */}
                    <div style={styles.column}>
                        <h4 style={styles.columnTitle}>{t('footer.products')}</h4>
                        <ul style={styles.linkList}>
                            <li>
                                <a
                                    style={styles.link}
                                    onClick={() => scrollOrNavigate('features')}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.features')}
                                </a>
                            </li>
                            <li>
                                <a
                                    style={styles.link}
                                    onClick={() => scrollOrNavigate('pricing')}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.pricing')}
                                </a>
                            </li>
                            <li>
                                <a
                                    style={styles.link}
                                    onClick={() => scrollOrNavigate('security')}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.security')}
                                </a>
                            </li>
                            <li>
                                <a
                                    style={styles.link}
                                    onClick={() => scrollOrNavigate('features')}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.integrations')}
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Company */}
                    <div style={styles.column}>
                        <h4 style={styles.columnTitle}>{t('footer.company')}</h4>
                        <ul style={styles.linkList}>
                            <li>
                                <a
                                    href="https://kirusa.com/company"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={styles.link}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.about')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://kirusa.com/contact"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={styles.link}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.contact')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://kirusa.com/careers"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={styles.link}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.careers')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://kirusa.com/blog"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={styles.link}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.blog')}
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div style={styles.column}>
                        <h4 style={styles.columnTitle}>{t('footer.legal')}</h4>
                        <ul style={styles.linkList}>
                            <li>
                                <a
                                    href="/privacy-policy"
                                    style={styles.link}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.privacy')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/terms-of-service"
                                    style={styles.link}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.terms')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/cookie-policy"
                                    style={styles.link}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    {t('footer.cookie')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/compliance"
                                    style={styles.link}
                                    onMouseEnter={(e) => e.target.style.color = '#3457D5'}
                                    onMouseLeave={(e) => e.target.style.color = '#BEBEBE'}
                                >
                                    Compliance
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom */}
                <div style={styles.bottom}>
                    {t('footer.copyright')}
                    <div style={styles.socialLinks}>
                        <a
                            href="https://www.facebook.com/kirusainc"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={styles.socialIcon}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#3457D5'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#BEBEBE'}
                        >
                            <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 24 24">
                                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                            </svg>
                        </a>
                        <a
                            href="https://twitter.com/kirusainc"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={styles.socialIcon}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#3457D5'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#BEBEBE'}
                        >
                            <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 24 24">
                                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                            </svg>
                        </a>
                        <a
                            href="https://www.linkedin.com/company/kirusa"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={styles.socialIcon}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#3457D5'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#BEBEBE'}
                        >
                            <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 24 24">
                                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
